// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__20mI0","colLarge":"styles_colLarge__3I180","col":"styles_col__2jcfu","colCheckbox":"styles_colCheckbox__2Zu37","actions":"styles_actions__13OEx"};